import React from 'react'

const PriceSummary = (props:any) => {
  const { adultPrice, adultCount, childPrice,
    childCount, infantPrice, infantCount,
    taxValue, otherValue, finalValue,
    convinienceFeeEntry, convinienceFeeCharged,
    baggageCharges, mealCharges, seatCharges
  } = props;
  function numberWithCommas(x:any) {
    return x?.toString()?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  return (
    <div className="priceSummary">
      <div className="title pr">
        <h5 className="mb-0">Price Summary</h5>
        <div className="person">
          <span><i className="fa-solid fa-user"></i> {adultCount} </span>
          {childCount > 0 && <span><i className="fa-solid fa-children"></i> {childCount} </span>}
          {infantCount > 0 && <span><i className="fa-solid fa-baby"></i> {infantCount} </span>}
        </div>
      </div>
      <div className="priceSummaryList">
        <ul>

          <li>
            <p>Adult <span>x</span> {adultCount}</p>
            <div className="price"><span>₹</span> {adultPrice} </div>
          </li>

          {
            childCount > 0 &&
            <li>
              <p>Child {childCount > 0 && <><span>x</span> {childCount}</>}</p>
              <div className="price"><span>₹</span> {childPrice} </div>
            </li>
          }

          {
            infantCount > 0 &&
            <li>
              <p>Infant {infantCount > 0 && <><span>x</span> {infantCount}</>} </p>
              <div className="price"><span>₹</span> {infantPrice} </div>
            </li>
          }
          {
            baggageCharges>0 &&
            <li>
              <p> Baggage Charges <span>+</span> </p>
              <div className="price"><span>₹</span> {baggageCharges} </div>
            </li>
          }

          {
            mealCharges >0 &&
            <li>
              <p> Meal Charges <span>+</span> </p>
              <div className="price"><span>₹</span> {mealCharges} </div>
            </li>
          }
          {
            seatCharges>0 &&
            <li>
              <p> Seat Charges <span>+</span> </p>
              <div className="price"><span>₹</span> {seatCharges} </div>
            </li>
          }
          <li>
            <p>Taxes and Surcharges <span>+</span> </p>
            <div className="price"><span>₹</span> {taxValue}</div>
          </li>

          {/* {
            otherValue > 0 &&
            <li>
              <p>Other <span>+</span> </p>
              <div className="price"><span>₹</span> {otherValue} </div>
            </li>
          } */}

          
          {
            convinienceFeeEntry > 0 &&
            <li>
              <p>Convinience fee entry <span>+</span> </p>
              <div className="price"><span>₹</span> {convinienceFeeEntry} </div>
            </li>
          }

          {
            convinienceFeeCharged > 0 &&
            <li>
              <p>Convinience fees charged <span>+</span> </p>
              <div className="price"><span>₹</span> {convinienceFeeCharged} </div>
            </li>
          }

          {/* <li>
            <p>Medical Policy <span></span> </p>
            <div className="price"><span>₹</span> 199</div>
          </li> */}

          <li className="total">
            <h4>Grand Total</h4>
            <div className="price">₹ {numberWithCommas(finalValue)} </div>
          </li>

        </ul>
      </div>
    </div>
  )
}

export default PriceSummary
